import {
  Box,
  Grid,
  GridItem,
  Heading,
  ListItem,
  OrderedList,
  Table,
  TableContainer,
  Tag,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { appRequest } from "routes";
import { formatDate, formatDateTime } from "utils/dateUtils/dateUtils";
import useFindBuyerName from "../../constants/function";

const ReconciliationDetails = ({ reconDetails }: any) => {
  const [orderData, setOrderData] = React.useState<any>({});

  const colorScheme = useColorModeValue("white", "gray.700");
  const borderColor = useColorModeValue("gray.300", "gray.600");

  const findBuyerNameById = useFindBuyerName();

  const getOrderData = async () => {
    try {
      let orderId = reconDetails?.order_id;
      const response: any = await appRequest("recon", "getOrderData", {
        orderId,
      });
      if (response.status === "success") {
        setOrderData(response?.data || {});
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getOrderData();
  }, []);

  return (
    <Box p={4} bg={colorScheme}>
      <VStack spacing={4} align="stretch">
        {/* Ticket Information */}
        <Box
          p={4}
          borderWidth="1px"
          borderRadius="lg"
          borderColor={borderColor}
        >
          <Heading fontSize={"lg"} color={"teal.400"} mb={3}>
            Reconciliation Details
          </Heading>
          <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={4}>
            <GridItem>
              <Text fontWeight="bold">Adaptor Ticket Price:</Text>
              <Text>{reconDetails?.price_from_adaptor}</Text>
            </GridItem>
            <GridItem>
              <Text fontWeight="bold">DMRC Ticket Price:</Text>
              <Text>₹ {reconDetails?.price_from_seller}</Text>
            </GridItem>

            <GridItem>
              <Text fontWeight="bold">Reconciliation Date:</Text>
              <Text>{formatDate(reconDetails?.created_at)}</Text>
            </GridItem>
            <GridItem>
              <Text fontWeight="bold">Status:</Text>
              <Tag
                colorScheme={
                  reconDetails.status === "RECONCILED"
                    ? "green"
                    : reconDetails.status === "PENDING"
                    ? "orange"
                    : "red"
                }
              >
                {reconDetails?.status}
              </Tag>
            </GridItem>
          </Grid>
        </Box>
        {reconDetails?.settlement_details &&
          reconDetails?.settlement_details.length > 0 && (
            <Box
              p={4}
            
              borderWidth="1px"
              borderRadius="lg"
              borderColor={borderColor}
            >
              <Heading fontSize={"lg"} color={"teal.400"} mb={3}>
                Settlement Details
              </Heading>
              <TableContainer
                overflow={'auto'}
              className="customScrollBar"
              >

              <Table size="sm"
              variant={'striped'}
                overflow={'auto'}
              className="customScrollBar"
              >
                <Thead>
                  <Tr>
                    <Th textAlign={'end'}>Amount</Th>
                    <Th>Reference</Th>
                    <Th>Date</Th>
                    <Th>Settlement ID</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {reconDetails?.settlement_details?.map((item: any) => (
                    <Tr key={item?.settlement_id}>
                      <Td textAlign={'end'}>₹ {item?.settlement_amount}</Td>
                      <Td>{item?.settlement_reference}</Td>
                      <Td>{formatDateTime(item?.settlement_timestamp)}</Td>
                      <Td>{item?.settlement_id}</Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
              </TableContainer>
            </Box>
          )}

        <Box
          p={4}
          borderWidth="1px"
          borderRadius="lg"
          borderColor={borderColor}
        >
          <Heading fontSize={"lg"} color={"teal.400"} mb={3}>
            Order Information
          </Heading>
          <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={4}>
            <GridItem>
              <Text fontWeight="bold">Buyer:</Text>
              <Text>{findBuyerNameById(orderData?.bap_id)}</Text>
            </GridItem>
            <GridItem>
              <Text fontWeight="bold">Order Id:</Text>
              <Text color={"gray"}>{orderData?.Order_Id}</Text>
            </GridItem>
            <GridItem>
              <Text fontWeight="bold">Order Date:</Text>
              <Text>{formatDate(orderData?.created_at)}</Text>
            </GridItem>
            <GridItem>
              <Text fontWeight="bold">Total Amount:</Text>
              <Text>₹ {orderData?.Amount}</Text>
            </GridItem>
            <GridItem>
              <Text fontWeight="bold">No Of Tickets:</Text>
              <Text>{orderData?.NoofTickets}</Text>
            </GridItem>
            {Array.isArray(orderData?.QRTickets) &&
              orderData?.QRTickets.length > 0 && (
                <>
                  <GridItem>
                    <Text fontWeight="bold">Status</Text>
                    <Tag
                      size={"sm"}
                      colorScheme={
                        orderData?.QRTickets[0]?.status === "CANCELLED"
                          ? "red"
                          : "green"
                      }
                    >
                      {orderData?.QRTickets[0]?.status}
                    </Tag>
                  </GridItem>
                  {orderData?.QRTickets[0]?.status === "CANCELLED" && (
                    <GridItem>
                      <Text fontWeight="bold">Cancellation Reason:</Text>
                      <Text>
                        {orderData?.QRTickets[0]?.cancel?.reason || "N/A"}
                      </Text>
                    </GridItem>
                  )}
                  {orderData?.QRTickets[0]?.status === "CANCELLED" && (
                    <GridItem>
                      <Text fontWeight="bold">Total Refund:</Text> ₹{" "}
                      {orderData?.QRTickets.reduce(
                        (total: any, ticket: any) => total + ticket?.refund,
                        0
                      )}
                    </GridItem>
                  )}
                </>
              )}
          </Grid>
          <Text fontWeight={700} my={2}>
            Qr Ticket Number
          </Text>
          <OrderedList>
            <Grid templateColumns={{ md: "repeat(3, 1fr)" }} gap={2}>
              {orderData?.QRTickets?.map((ticket: any) => (
                <ListItem fontSize={"sm"} fontWeight={500} color={"gray"}>
                  {ticket?.qR_Ticket_No}
                </ListItem>
              ))}
            </Grid>
          </OrderedList>
        </Box>

        {/* Payment Information */}
        <Box
          p={4}
          borderWidth="1px"
          borderRadius="md"
          borderColor={borderColor}
        >
          <Heading fontSize={"lg"} color={"teal.400"} mb={3}>
            Payment Information
          </Heading>
          <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={4}>
            <GridItem>
              <Text fontWeight="bold">Payment Method:</Text>
              <Text>{orderData?.Payment_Mode}</Text>
            </GridItem>
            <GridItem>
              <Text fontWeight="bold">Transaction ID:</Text>
              <Text color={"gray"}>{reconDetails?.bank_transaction_id}</Text>
            </GridItem>
            <GridItem>
              <Text fontWeight="bold">Payment Ref No:</Text>
              <Text color={"gray"}>{reconDetails?.payment_reference_no}</Text>
            </GridItem>
          </Grid>
        </Box>
      </VStack>
    </Box>
  );
};

export default ReconciliationDetails;
